import { useState, useEffect, useCallback } from 'react';

const getInitialPermission = () => {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return 'unsupported';
  }
  return Notification.permission;
};

export const useNotificationPermission = () => {
  const [permission, setPermission] = useState(getInitialPermission());

  useEffect(() => {
    setPermission(getInitialPermission());
  }, []);

  const requestPermission = useCallback(async () => {
    if (permission !== 'default') {
      return;
    }

    if (!('Notification' in window)) {
      setPermission('unsupported');
      return;
    }

    try {
      const status = await Notification.requestPermission();
      setPermission(status);
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      setPermission('default');
    }
  }, [permission]);

  return { permission, requestPermission };
};
